import { Button, Stack } from "@mui/material";
import * as React from "react";
import { BranchLimitControl } from "./BranchLimitControl";
import { useBranchLimits } from "./BranchLimits";
import { useLanguage } from "./Language";
import { ReservesFilterControl } from "./ReservesFilterControl";
import {
  WindowLocationContext,
  WindowLocationProvider,
} from "./WindowLocation";

export interface ReservesSearchEvent {
  branchFilters: string[];
  department: string;
  course: string;
  instructor: string;
}

export interface ReservesSearchFormProps {
  onClickSearch: (event: ReservesSearchEvent) => void;
}

export interface ReservesOptionsParameters {
  branchFilters: string[];
  targetAudience: string;
  department: string;
  course: string;
  instructor: string;
}

export interface ReservesDepartmentOption {
  name: string;
  value: string;
  comment: string;
}
export interface ReservesCourseOption {
  name: string;
  value: string;
  comment: string;
}
export interface ReservesInstructorOption {
  value: string;
  name: string;
  displayName: string;
}

export interface ReserveOptions {
  departments: ReservesDepartmentOption[];
  courses: ReservesCourseOption[];
  instructors: ReservesInstructorOption[];
}

export interface ReservesOptionsReturn {
  success: boolean;
  options: ReserveOptions;
}

export const ReservesSearchForm: React.FC<ReservesSearchFormProps> = (
  props
) => {
  const { onClickSearch } = props;
  const { selectedBranchIds } = useBranchLimits();
  const { translate } = useLanguage();

  const [department, setDepartment] =
    React.useState<ReservesDepartmentOption["value"]>(null);
  const [instructor, setInstructor] =
    React.useState<ReservesInstructorOption["value"]>(null);
  const [course, setCourse] =
    React.useState<ReservesCourseOption["value"]>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onClickSearch({
      branchFilters: [...selectedBranchIds],
      department: department,
      course: course,
      instructor: instructor,
    });
  };

  const handleClear = () => {
    setInstructor(null);
    setDepartment(null);
    setCourse(null);
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Stack gap={2} maxWidth={"320px"}>
        <BranchLimitControl></BranchLimitControl>
        <WindowLocationProvider>
          <ReservesFilterControl
            department={department}
            instructor={instructor}
            course={course}
            onChangeCourse={(newCourse) => {
              setCourse(newCourse);
            }}
            onChangeDepartment={(newDepartment) => {
              setDepartment(newDepartment);
            }}
            onChangeInstructor={(newInstructor) => {
              setInstructor(newInstructor);
            }}
          ></ReservesFilterControl>
        </WindowLocationProvider>

        <Stack gap={1} direction="row">
          <Button variant="contained" type="submit">
            {!instructor && !course && !department
              ? translate("showAllReserves")
              : translate("showReserves")}
          </Button>
          <Button variant="text" onClick={handleClear}>
            {translate("clear")}
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
